import React from "react";
import { TransactionRule } from "../../common/types/transactionRule";
import { Counterparty } from "../../common/types/counterparty";
import { RuleAction } from "./RuleAction/RuleAction";

interface Props {
    rule: Pick<TransactionRule, "actions">;
    counterparties: Counterparty[];
}

export const TransactionRuleActions: React.FC<Props> = ({ rule, ...rest }) => (
    <>
        {rule.actions?.map((action) => (
            <div key={action.id}>
                <RuleAction action={action} {...rest} />
            </div>
        ))}
    </>
);
